<template>
  <div class="bj">
    <!-- <div class="wrap"> -->
      <img src="../../assets/img/logo.png" alt="" class="logo">
      <div class="content">
        

        
        <div class="title">
          <div class="t">{{$t('chinaIndex.title')}} <br>{{$t('chinaIndex.title1')}}</div>
          <div class="xian"></div>
          <div class="h_title">{{$t('chinaIndex.tips')}}</div>
        </div> 
        <div class="pa">
          <div class="con_form">
          <div class="logIn">{{$t('chinaIndex.login')}}</div>
          <el-form>
            <el-form-item :label="$t('chinaIndex.username')">
              <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chinaIndex.Password')" >
              <el-input v-model="form.password" show-password></el-input>
              <div class="forgot">
                {{$t('chinaIndex.Forgot_Your_Password')}}
              </div>
            </el-form-item>
            <!--  -->
            <el-form-item :label="$t('chinaIndex.FA')" v-if="show">
              <el-input v-model="form.code"></el-input>
              <div class="forgot">
                {{$t('chinaIndex.Forgot_Your_FA_Code')}}
              </div>
              <div class="tips " v-if="result.success == false">
                Incorrect user name or password.
              </div>
            </el-form-item>
          </el-form>

          <div class="bth_wrap">
            <el-button class="login" @click="login">{{$t('chinaIndex.LogIn')}}</el-button>
            <div class="signUp">{{$t('chinaIndex.SignUp')}}</div>
          </div>
        </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import carbonRegistry from "@/api/carbonRegistry.js";
 
export default {
  name: 'Home',
  components: {
  },
  data(){
    return {
      form:{
        username:'',
        password:'',
        code:''
      },
      show:false,
      result:{},
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    }
  },
  mounted(){
    window.addEventListener('keydown',this.keyDown);
    window.addEventListener('keydown',this.keyDownLogin);
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        window.fullHeight = document.documentElement.clientHeight;
        that.screenWidth = window.fullWidth; // 宽
        that.windowHeight = window.fullHeight; // 高
        // console.log("实时屏幕高度：", that.windowHeight);
      })();
    };
  },
  methods:{
    login(){
      if(this.form.username && this.form.password){
        this.show = true
      }
      if(this.form.username && this.form.password && this.form.code){
        carbonRegistry.getOauthLogin(res => {
          this.result = res.data
          if(res.data.success){
            this.$router.push('/chinaCarbon')
            sessionStorage.setItem('login',JSON.stringify(res.data))
            sessionStorage.setItem('user',JSON.stringify(this.form))
          }
        },this.form)
        
      }
    },

    keyDown(e){
      if((this.form.username && this.form.password) && e.keyCode == 13){
        this.show = true
      }
    },
    keyDownLogin(e){
      if(this.show && e.keyCode == 13){
        this.login()
      }
    }


  },
  //修改列表页的meta值，false时再次进入页面会重新请求数据。
  beforeRouteLeave(to, from, next) {
    console.log('to login',to)
    if (to.path == "/carbon") {
      to.meta.keepAlive = false;
    } 
    next();
  },
}
</script>

<style lang="scss" scoped>
.bj{
  width: 100%;
  height: 100vh;
  // min-height: 100%;
  background: url('../../assets/img/bj.png') no-repeat ;
  background-size: 100% 100%;
  position: relative;
  // .wrap{
    // margin: 120px 239px 125px 45px;
    .logo{
      width: 297px;
      height: 57px;
      position:absolute;
      top: 35px;
      left: 45px;
    }
    .content{
      display: flex;
      justify-content: center;
      width: 1200px;
      // padding: 100px 139px 120px 139px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .title{
        width: 800px;
        margin-top: 100px;
        .t{
          font-size:43px;
          font-family: Gotham Regular;
          font-weight: 100;
          color: #FFFFFF;
          line-height: 106px;
        }
        .xian{
          display: inline-block;
          width: 108px;
          opacity: 0.29;
          border-bottom: 10px solid #FFFFFF;
          border-radius: 10px;
        }
        .h_title{
          font-size: 18px;
          font-family: Gotham Regular;
          font-weight: 100;
          color: #FFFFFF;
          margin-top: 98px;
        }
      }
      .pa{
        width: 510px;
        height: 600px;
        position: relative;
        .con_form{
          height: 100%;
          background: #FFFFFF;
          border-radius: 20px;
          padding:50px 60px 0px;
          .logIn{
            font-size: 40px;
            font-family: Arial-BoldMT, Arial;
            font-weight: bold;
            color: #1E1E1E;
            text-align: center;
            margin-bottom: 50px;
          }
          .login{
            width: 100%;
            height: 56px;
            background: #158869;
            border-radius: 10px;
            color: #ffffff;
            font-size: 16px;
            font-family: Gotham Regular;
          }
          .signUp{
            text-align: center;
            font-size: 16px;
            font-family: Gotham Regular;
            color: #158869;
            margin-top: 20px;
          }
        }
      }
      
    }
  // }
}
.bth_wrap{
  width: 74%;
  position: absolute;
  bottom: 0px;
}
.forgot{
  text-align: right;
  font-size: 14px;
  font-family: Gotham Regular;
  color: #498D86;
}
.tips{
  text-align: left;
  font-size: 14px;
  font-family: Gotham Regular;
  color: red;
}
::v-deep .el-form-item:first-child{
  margin-bottom: 10px;
}
::v-deep .el-form-item__label{
  font-size: 16px;
  font-family: Gotham Regular;
  color: #366F67;
}
::v-deep .el-input__inner{
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #E1E1E1;
  padding: 0;
  // margin-top: 20px;
}
::v-deep .el-form-item{
  margin-bottom: 0;
}
::v-deep .el-input__inner:focus{
  border-bottom: 1px solid #E1E1E1;
}

::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #333;
}

::v-deep .el-icon-view:before{
  font-size: 22px !important;
}
</style>
